import upperFirst from 'lodash/upperFirst';

import { colors } from '../theme';

const DAY = 24 * 60 * 60 * 1000;
const PODIUM_COLORS = [colors.top, colors.rankSilver, colors.rankBronze];
// The rankings are made in Paris: the days of a week don't depend on the computer.
const TIME_ZONE = 'Europe/Paris';

// Gold, silver and bronze for the podium, grey (or the color given) after.
const getRankColor = (rank: number, other: string = colors.rankOther) => PODIUM_COLORS[rank - 1] || other;

// The ranking is made on Sunday evening for the 7 days before: "29 sept. – 5 oct." (Monday to Sunday).
const getRankingWeekLabel = (createdAt: number, language: string) => {
  const format = new Intl.DateTimeFormat(language, { day: 'numeric', month: 'short' });
  return `${format.format(new Date(createdAt - 6 * DAY))} – ${format.format(new Date(createdAt))}`;
};

// "Semaine du 21 au 27 sept.", "Semaine du 28 sept. au 4 oct.": the month once when both days share it.
const getRankingWeekName = (createdAt: number, language: string, t: any) => {
  const start = new Date(createdAt - 6 * DAY);
  const end = new Date(createdAt);
  const day = new Intl.DateTimeFormat(language, { day: 'numeric', timeZone: TIME_ZONE });
  const dayMonth = new Intl.DateTimeFormat(language, { day: 'numeric', month: 'short', timeZone: TIME_ZONE });
  const month = new Intl.DateTimeFormat(language, { month: 'numeric', timeZone: TIME_ZONE });
  const values = {
    start: dayMonth.format(start),
    startDay: day.format(start),
    end: dayMonth.format(end),
    endDay: day.format(end),
  };
  const key = month.format(start) === month.format(end) ? 'admin.rankings.weekSameMonth' : 'admin.rankings.week';
  return t(key, values);
};

// Year of the Sunday of the week.
const getRankingWeekYear = (createdAt: number, language: string) => (
  new Intl.DateTimeFormat(language, { year: 'numeric', timeZone: TIME_ZONE }).format(new Date(createdAt))
);

// "Octobre 2026": the month of the Sunday, groups the weeks of the picker.
const getRankingWeekMonth = (createdAt: number, language: string) => upperFirst(
  new Intl.DateTimeFormat(language, { month: 'long', year: 'numeric', timeZone: TIME_ZONE }).format(new Date(createdAt))
);

export {
  getRankColor,
  getRankingWeekLabel,
  getRankingWeekMonth,
  getRankingWeekName,
  getRankingWeekYear,
};
